import React from "react";
import websiteNft from "../../assets/website-nft.png";
import glyph1 from "../../assets/glyph1.png";
import glyph2 from "../../assets/glyph2.png";
import { Link } from "react-scroll";
const Home = () => {
  return (
    <div
      className="h-screen pt-14 flex flex-col-reverse lg:flex-row items-center"
      id="home"
    >
      <div className="w-full lg:w-1/2 flex justify-center pr-4 items-start relative">
        <img
          src={glyph1}
          alt="glyph1"
          className="h-28 translate-x-2 lg:translate-y-[25rem] lg:translate-x-0 lg:h-48 translate-y-40 z-10 opacity-70"
        ></img>
        <img
          src={websiteNft}
          alt="website-nft"
          className="h-[45vh] lg:h-[72vh]"
        ></img>

        <img
          src={glyph2}
          alt="glyph2"
          className="h-28 lg:h-48 z-10 opacity-70"
        ></img>
      </div>
      <div className="w-full lg:w-1/2 h-80 lg:mt-0 flex flex-col lg:mr-32 items-center justify-center">
        <p className="site-caption">
          Ea voluptate do proident velit exercitation reprehenderit pariatur
          dolore ullamco velit.
        </p>
        <Link
          activeClass="active"
          to="social"
          spy={true}
          duration={500}
          smooth={true}
          className="cursor-pointer action-button"
        >
          Join Us
        </Link>
      </div>
    </div>
  );
};
export default Home;
